export const iconFontAwesomeChildhoodSchool = (
	<i className="fa-solid fa-school"></i>
);
